import request from '@/axios'
import qs from 'qs'


/**
 * @Description: 获取发布的资料
 * @author Li Yanjie
 * @date 2020/7/9
 * @param fileType {Number} 文件类型：1-服务指导，2-产品资料，3-解决方案
 * @return Promise
 */
export function getPublishedFileList(fileType){
  return request({
    method:'get',
    url:'/api/file/getPublishedFileList',
    params:{fileType}
  })
}


/**
 * imgHas
 * @Description: 根据id获取对应新闻正文内容
 * @author Li Yanjie
 * @date 2020/7/9
 * @param id {Number} 新闻id
 * @return Promise
 */
export function getNewsById(id){
  return request({
    method:'get',
    url:'/api/news/getNewsById',
    params:{id}
  })
}

/**
 * imgHas
 * @Description: 获取已发布的图文展示新闻
 * @author Li Yanjie
 * @date 2020/7/9
 * @return Promise
 */
export function getGraphicNews(){
  return request({
    method:'get',
    url:'/api/news/getGraphicNews',
  })
}

/**
 * @Description: 获取已发布的列表展示新闻
 * @author Li Yanjie
 * @date 2020/7/9
 * @return Promise
 */
export function getListNews(){
  return request({
    method:'get',
    url:'/api/news/getListNews',
  })
}

/**
 * @Description: 获取少量的发布的资料
 * @author Li Yanjie
 * @date 2020/7/9
 * @param fileType {Number} 文件类型：1-服务指导，2-产品资料，3-解决方案
 * @return Promise
 */
export function getPublishedFileListLimit(fileType){
  return request({
    method:'get',
    url:'/api/file/getPubFileListTen',
    params:{fileType}
  })
}


/**
 * @Description: 搜索发布文件列表
 * @author Li Yanjie
 * @date 2020/7/9
 * @param fileType {Number} 文件类型：1-服务指导，2-产品资料，3-解决方案
 * @param params {String} 关键字
 * @return Promise
 */
export function searchPubFiles(fileType,params){
  return request({
    method:'get',
    url:'/api/file/searchPubFiles',
    params:{fileType,params}
  })
}
